"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Base = _interopRequireDefault(require("./Base"));

var _Catalog = _interopRequireDefault(require("./Catalog"));

var _Category = _interopRequireDefault(require("./Category"));

var _Pizza = _interopRequireDefault(require("./Pizza"));

var _Simple = _interopRequireDefault(require("./Simple"));

var _Step = _interopRequireDefault(require("./Step"));

var _Edge = _interopRequireDefault(require("./Edge"));

var _Extraingredient = _interopRequireDefault(require("./Extraingredient"));

var _Question = _interopRequireDefault(require("./Question"));

var _Flavor = _interopRequireDefault(require("./Flavor"));

var _Option = _interopRequireDefault(require("./Option"));

var _Size = _interopRequireDefault(require("./Size"));

var _Dough = _interopRequireDefault(require("./Dough"));

var _Drink = _interopRequireDefault(require("./Drink"));

var _Reference = _interopRequireDefault(require("./Reference"));

var _Availability = _interopRequireDefault(require("../Availability"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const classes = {
  Base: _Base.default,
  Catalog: _Catalog.default,
  Category: _Category.default,
  Pizza: _Pizza.default,
  Simple: _Simple.default,
  Step: _Step.default,
  Size: _Size.default,
  Edge: _Edge.default,
  Extraingredient: _Extraingredient.default,
  Question: _Question.default,
  Flavor: _Flavor.default,
  Option: _Option.default,
  Dough: _Dough.default,
  Drink: _Drink.default
};

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

class Builder {
  static factory(className, ...args) {
    return new classes[className]();
  }

  static generateRandomId(prefix = '') {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return prefix + timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
  }

  static mountSchema(item) {
    let $class = item.type.capitalize();
    let obj = Builder.factory($class);

    if (item.ref_id) {
      _Reference.default.addToReference(item.ref_id, obj);
    }

    if (item.availability) {
      item.availability = _Availability.default.fromObject(item.availability);
    }

    ['extra_ingredients', 'edges', 'doughs', 'items', 'sizes'].map(prop => {
      if (Array.isArray(item[prop]) && item[prop].length > 0) {
        obj.addItems(item[prop].map(Builder.mountSchema));
        obj[prop].sort((a, b) => a.position - b.position);
      }

      delete item[prop];
    });

    for (var param in item) {
      obj[param] = item[param];
    }

    return obj;
  }

  static mountSchemaByList(item, list) {
    let $class = item.type.capitalize();
    let obj = Builder.factory($class);
    let to_process = { ...item
    };
    delete to_process.items;
    delete to_process.edges;
    delete to_process.doughs;
    delete to_process.extra_ingredients;

    for (var k in to_process) {
      obj[k] = to_process[k];
    }

    if (item.ref_id) {
      _Reference.default.addToReference(item.ref_id, obj);
    }

    if (item.availability) {
      item.availability = _Availability.default.fromObject(item.availability);
    }

    let tmp_list = list.filter(child => child.parent == item._id);

    if (tmp_list.length > 0) {
      obj.addItems(tmp_list.map(i => Builder.mountSchemaByList(i, list)));
    }

    return obj;
  }

  static executeOnSchema(schema, callback, ...extra_params) {
    for (var field of ['items', 'extra_ingredients', 'edges', 'doughs', 'sizes']) {
      if (schema[field] && schema[field].length > 0) {
        for (var item of schema[field]) {
          callback(item, ...extra_params);
          Builder.executeOnSchema(item, callback, ...extra_params);
        }
      }
    }
  }

}

exports.default = Builder;